import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';
import GraphQLDeviceRequester from '@cobliteam/api-lib/src/dashboard/device/GraphQLDeviceRequester';
import { DatadogTrack } from '@cobliteam/datadog-rum';
import type { LoadDevicesRequest } from '@cobliteam/store';
import { loadDevicesFailed, loadDevicesSucceeded } from '@cobliteam/store/src/Devices/actionCreators';
import { DevicesActionTypes } from '@cobliteam/store/src/Devices/actionTypes';
import Alert from '@cobliteam/ui/components/Alert';
import { call, put, takeLatest } from 'redux-saga/effects';

const grahpQLDeviceRequester = new GraphQLDeviceRequester();

export function* requestLoadDevicesSaga(action: LoadDevicesRequest) {
  const { vehicleGroupIds, includeObservationPeriodTrigger } = action.payload;

  try {
    const devices: DeviceFragment[] = yield call(grahpQLDeviceRequester.getDevices, { groupIds: vehicleGroupIds, includeObservationPeriodTrigger });

    yield put(loadDevicesSucceeded(devices));
  } catch (err) {
    DatadogTrack.error(err as Error, { EventSource: 'DevicesSaga' });
    yield put(loadDevicesFailed());
    Alert.error('Houve um erro ao carregar os dispositivos, tente novamente mais tarde.');
  }
}

export function* DevicesSagasListener() {
  yield takeLatest(DevicesActionTypes.LOAD_DEVICES_REQUEST, requestLoadDevicesSaga);
}
